export { MapSearchboxComponent} from './lib/map-searchbox.component'

export * from './lib/feature-searchbox.module';

export {SearchboxService} from './lib/searchbox.service'
